import { render, staticRenderFns } from "./AccordionList.vue?vue&type=template&id=7a824b72"
import script from "./AccordionList.vue?vue&type=script&lang=js"
export * from "./AccordionList.vue?vue&type=script&lang=js"
import style0 from "./AccordionList.vue?vue&type=style&index=0&id=7a824b72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports